import { apiClient } from '@/api/client'
import type { ControllerStatusItem } from './types'

export async function fetchControllerStatuses(): Promise<ControllerStatusItem[]> {
  const { data } = await apiClient.get<ControllerStatusItem[]>('/portal/settings/api/v2/controller-status')
  return data
}
